module.exports = __webpack_public_path__ + "static/media/logos-deusto.379606fb.png";